<script setup lang="ts">
import dayjs from '@/utils/day';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiCampsiteMediaInfoProps {
  item: any;
  showUser?: boolean;
}
const props = withDefaults(defineProps<CiCampsiteMediaInfoProps>(), {
  showUser: true,
});

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

/********************
 * REFS & VARS       *
 ********************/
const userImage = computed(() => {
  return props.item.user ? props.item.user.image || null : null;
});

const userName = computed(() => {
  if (props.item.user?.name) {
    return props.item.user.name;
  }

  if (props.item.picture_type === 'campsite') {
    return $gettext('Campsite owner');
  }

  return $gettext('Unknown');
});

const monthOfStay = computed(() => {
  if (!props.item.month_of_stay) {
    return props.item.month_of_stay;
  }
  return `${dayjs(props.item.month_of_stay).format('MMM')} ${dayjs(props.item.month_of_stay).format('YYYY')}`;
});

const dateCreated = computed(() => {
  return $gettext('uploaded on %{ date }', { date: dayjs(props.item.created_at).format('LL') });
});
</script>

<template>
  <div class="bg-gray-10 p-4">
    <div
      v-if="item.title"
      class="font-bold"
    >
      {{ item.title }}
    </div>
    <p
      v-if="item.description"
      class="description"
    >
      {{ item.description }}
    </p>
    <div
      v-if="showUser"
      class="row"
    >
      <div class="col-12">
        <div class="flex flex-row items-center">
          <CiUserAvatar
            :user-image="userImage"
            class="shrink-0 grow-0 pr-2"
            bg-class="flex items-center"
            size="lg"
          />
          <div>
            <span class="text-small-book ml-1 font-bold">{{ userName }}</span>
            <div class="text-small-book ml-1 text-gray">
              <span class="pr-1">{{ dateCreated }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-small-book flex flex-col text-gray"
    >
      <div v-if="monthOfStay">
        <span>{{ $gettext('Date of stay') }}</span>: {{ monthOfStay }}
      </div>
      <div v-if="dateCreated">
        {{ dateCreated }}
      </div>
    </div>
  </div>
</template>
